import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { POSITION_FORM, EDITABLE_LIST_FIELDS_NAME } from 'src/constants/FormNames';

import { getMode, getList } from 'src/reducers/common/editableListReducer';
import { REDUCER_NAME, updatePositions } from 'src/reducers/clients/positions';

import { EditableList } from 'src/components';

const EditableListFormed = reduxForm({
  form: POSITION_FORM
})(EditableList);

const mapStateToProps = state => ({
  initialValues: { [EDITABLE_LIST_FIELDS_NAME]: getList(REDUCER_NAME, state) },
  mode: getMode(REDUCER_NAME, state),
  listData: getList(REDUCER_NAME, state),
  fieldName: 'name'
});
const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(updatePositions(data[EDITABLE_LIST_FIELDS_NAME]));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(EditableListFormed);
